import request from '../request'

export default {
  login: (credentials) => {
    return request.post('auth/login', credentials)
  },

  forgotPassword: (email) => {
    return request.post('auth/forgot-password', { EMAIL: email })
  },

  resetPassword: (TOKEN, PASSWD) => {
    return request.post('auth/reset-password', { TOKEN, PASSWD })
  }
}
